interface Typography {
    fontSize: string;
    fontWeight?: string | number;
    lineHeight?: string | number;
    letterSpacing?: string | number;
}

export const typography: Record<string, Typography> = {
    subtitle: {
        fontSize: 'var(--v-theme-typography-subtitle-size, 1rem)',
        lineHeight: 'var(--v-theme-typography-subtitle-line-height, 1.75)',
        letterSpacing: 'var(--v-theme-typography-subtitle-letter-spacing, 0.00938em)',
    },
    body: {
        fontSize: 'var(--v-theme-typography-body-size, 1rem)',
        lineHeight: 'var(--v-theme-typography-body-line-height, 1.5)',
        letterSpacing: 'var(--v-theme-typography-body-letter-spacing, 0.00938em)',
    },
    // 기본적인 fullwidth 기준 버튼 폰트들 1080 기준 42px
    button: {
        fontSize: 'var(--v-theme-typography-button-size, 1.1rem)',
        lineHeight: 'var(--v-theme-typography-button-line-height, 1.75)',
        letterSpacing: 'var(--v-theme-typography-button-letter-spacing, 0.02857em)',
    },
}
